import { render, staticRenderFns } from "./VideoAvatar.vue?vue&type=template&id=615cef09&"
import script from "./VideoAvatar.vue?vue&type=script&lang=js&"
export * from "./VideoAvatar.vue?vue&type=script&lang=js&"
import style0 from "./VideoAvatar.vue?vue&type=style&index=0&id=615cef09&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports